import React from 'react'
import { ScriptEditPage } from './ScriptEditPage'

export const ScriptAddPage: React.FC = () => {
  return <ScriptEditPage isNew />
}
